export const AUTH_RETURN_URL_KEY = 'authReturnUrl';

export const isSafeReturnUrl = (url) => (
  Boolean(url)
  && url.startsWith('/v2/')
  && !url.startsWith('/v2/login')
);

export const saveAuthReturnUrl = (path) => {
  if (isSafeReturnUrl(path)) {
    sessionStorage.setItem(AUTH_RETURN_URL_KEY, path);
  }
};

export const getPostLoginPath = () => {
  const returnUrl = sessionStorage.getItem(AUTH_RETURN_URL_KEY);
  sessionStorage.removeItem(AUTH_RETURN_URL_KEY);

  if (isSafeReturnUrl(returnUrl)) {
    return returnUrl;
  }

  return '/v2/nsirs';
};
